import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box } from '@material-ui/core'
import { useStyles } from './style'
import _ from 'lodash'
import moment from 'moment'
import { useLocation, useParams, useHistory } from 'react-router-dom'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import { COMMON } from '../../utils/constants'
import * as messageTypes from '../../utils/messageTypes'
import { DisplayMessage, Loader } from '../../Components'
import { HISTORY, getTableHeadings, EVENT_TYPE, EVENT_SUBTYPE, defaultSubType } from './constant'
import { TableOutline } from '../../elements'
import { SORTORDER } from '../../utils/constants'
import { timeZoneAbbrs } from '../../utils/momentTimezones'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

function History(props) {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const [events, setEvents] = useState()
  const [tableData, setTableData] = useState([])
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [sortBy, setSortBy] = useState('end_time')
  const [order, setOrder] = useState('')
  const [headings, setHeadings] = useState(getTableHeadings(HISTORY, classes))
  const [open, setOpen] = useState()
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [totalCount, setTotalCount] = useState()
  const [loading, setLoading] = useState(false)
  const [tableLoading, setTableLoading] = useState(true)

  const { programId, siteId } = useParams()

  const getTableData = () => {
    const { currentUser } = props
    setLoading(true)
    setTableLoading(true)
    systemsService.getTableData(currentUser.account_id, programId, siteId, page, rowsPerPage, -1, sortBy, order)
      .then(systemTableData => {
        setLoading(false)
        setTableLoading(false)
        props.setTotal(systemTableData.total_count)
        props.setHistoryCount(systemTableData.time_based_total_count)
        props.setOngoingCount(systemTableData.total_count - systemTableData.time_based_total_count)
        setTotalCount(systemTableData.time_based_total_count)
        setEvents(systemTableData.events)
        setSystemTable(systemTableData.events)
      })
      .catch(error => {
        setLoading(false)
        setTableLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const setSystemTable = (systemTableData) => {
    let systemTable = []
    systemTableData.map(obj => {
      const startTime = moment(_.get(obj, 'start_time', ''))
      const endTime = moment(_.get(obj, 'end_time', ''))
      const duration = moment.duration(endTime.diff(startTime))
      let tableObj = [
        {
          id: 'eventName',
          value: _.get(obj, 'name', ''),
          statusValue: _.get(obj, 'status', ''),
          handleClick: (val) => { history.push(`/programs/${programId}/events/${obj.id}`) }
        },
        {
          id: 'eventType',
          value: _.get(obj, 'type', '') ? EVENT_TYPE[obj.type] || '' : '-',
        },
        {
          id: 'eventSubType',
          value: _.get(obj, 'subtype', '') ? EVENT_SUBTYPE[obj.subtype] || '' : defaultSubType[obj.type] || <Box textAlign="center">{'-'}</Box>,
        },
        {
          id: 'starttime',
          value: moment(obj.start_time).tz(props.timeZone).format('MMMM DD, YYYY h:mm A zz'),
        },
        {
          id: 'endtime',
          value: moment(obj.end_time).tz(props.timeZone).format('MMMM DD, YYYY h:mm A zz'),
        },
        {
          id: 'eventDuration',
          value: _.get(obj, 'start_time', '') && _.get(obj, 'end_time', '') ? `${Math.floor(duration.asHours())} hour(s) ${moment.utc(duration.asMilliseconds()).format("mm")} minute(s)` : '--'
        },
        {
          id: 'scheduledPower',
          value: <Box className={classes.center}>{_.get(obj, 'avg_kw_scheduled', '-')}</Box>,
        },
        {
          id: 'actualPower',
          value: <Box className={classes.center}>{_.get(obj, 'type', '') === 'BATTERY_CHARGE' ? _.get(obj, 'avg_kw_charged', '-') : _.get(obj, 'avg_kw_discharged', '-')}</Box>,
        },
        {
          id: 'scheduledEnergy',
          value: <Box className={classes.center}>{_.get(obj, 'avg_kwh_scheduled', '')}</Box>,
        },
        {
          id: 'actualEnergy',
          value: <Box className={classes.center}>{_.get(obj, 'type', '') === 'BATTERY_CHARGE' ? _.get(obj, 'avg_kwh_charged', '-') : _.get(obj, 'avg_kwh_discharged', '-')}</Box>,
        },
        {
          id: 'status',
          value: obj['opt-in_status'] ? 'Opted In' : 'Opted Out',
        }
      ]
      systemTable.push(tableObj)
    })
    setTableData(systemTable)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
    setLoading(true)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const handleSortData = (sortedObj) => {
    const { currentUser } = props
    const modifiedObj = _.cloneDeep(headings)
    modifiedObj.forEach((obj, index) => {
      if (obj.id === sortedObj.id && obj.isSortable) {
        modifiedObj[index].sortOrder =
          obj.sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
      } else {
        modifiedObj[index].sortOrder = SORTORDER.ASC
      }
    })
    const selectedObj = modifiedObj.find((obj) => sortedObj.id === obj.id)
    const selectedSortOrder = selectedObj.sortOrder === SORTORDER.ASC ? SORTORDER.ASC : SORTORDER.DESC
    setLoading(true)
    setPage(1)
    setSortBy(sortedObj.id)
    setOrder(selectedSortOrder)
    setHeadings(modifiedObj)
  }

  useEffect(() => {
    getTableData()
  }, [page, rowsPerPage, sortBy, order])

  return (
    <>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <TableOutline
        tableHeadings={headings}
        tableData={tableData}
        totalElement={totalCount}
        loading={tableLoading}
        pagination={tableData.length > 0}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handlePageChange}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleSortData={handleSortData}
      />
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, timeZone } = auth
  return { currentUser, timeZone }
}

export default connect(mapStateToProps, {})(History)